/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// IE9, IE10, IE11 support (如果不需要 IE 可以刪掉)
// import 'core-js/es/array';
// import 'core-js/es/object';
// ...

// Zone JS 是 Angular 必須的
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * 其他環境特定 polyfills 可以放這裡
 * 例如：根據環境決定載入不同的 lib
 */